import useRouter from 'common/hooks/use-router';
import useItem from 'common/hooks/useItem';
import React, { useCallback, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AlertsContext from 'common/providers/alerts';
import DepartmentForm from './DepartmentForm';

function Department() {
  const { t } = useTranslation();
  const router = useRouter();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem('departments', id, {
    populate: ['establishments'],
  });

  useEffect(() => {
    if (error) {
      setAlert(error, 'danger');
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t('common.saved'), 'success');
      router.navigate('/departments');
    }
  }, [setAlert, router, error, t]);

  const onSubmit = useCallback(
    async (dataDepartment: any) => {
      const department = { ...dataDepartment };

      try {
        if (department.id) {
          await updateItem(department.id, department);
        } else {
          await saveItem(department);
        }
      } catch (e: any) {
        return e;
      }

      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <DepartmentForm onSubmit={onSubmit} department={item} />
  );
}

export default Department;
